import React from "react";
import ConteudoEsquerda from "./AuthCommon/ConteudoEsquerda";
import FormWrapper from "./AuthCommon/FormWrapper";
import CommonInputSenha from "../../components/forms/CommonInputSenha";
import { AppContext } from "../../contexts/AppContext";
import { handleChange } from "../../helpers/handleFormChanges";
import { useLocation } from "react-router-dom";
import Authentication from "../../helpers/Authentication";
import Validation from "../../helpers/Validation";
import ErrorSwal from "../../components/Swal/errorSwal";
import useApi from "../../hooks/useApi";
import AuthApiClient from "../../api/auth";
import CommonSwal from "../../components/Swal/commonSwal";

function ResetSenha() {
  const [values, setValues] = React.useState({});
  const { baseUrl } = React.useContext(AppContext);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const recovery = queryParams.get("recovery");

  const resetarSenhaApi = useApi(AuthApiClient.resetarSenha);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("password", values.senha);
    formData.append("repeat_password", values.confirmSenha);
    formData.append("tipo", "reset");
    formData.append("token", recovery);

    const validacoes = handleUserValidation(formData);
    if (validacoes) return ErrorSwal({ ...validacoes });

    const response = await resetarSenhaApi.request(formData);
    if (!response) return;
    CommonSwal({
      title: "Senha alterada com sucesso!",
      text: "Sua nova senha será solicitada no seu próximo acesso.",
      icon: "success",
    }).then((result) => {
      if (result.isConfirmed) window.location.href = `${baseUrl}login`;
    });
  };

  const handleUserValidation = (formData) => {
    if (Validation.verificarForm(formData))
      return {
        text: "Favor preencher todos os dados obrigatórios.",
      };
    if (values.senha !== values.confirmSenha)
      return {
        text: "As senhas precisam ser iguais.",
      };
    const validacaoSenha = Authentication.verificarSenha(values?.senha);
    if (validacaoSenha)
      return {
        html: validacaoSenha,
      };
  };

  return (
    <>
      <div className="container-fluid p-0">
        <div className="row g-0">
          <ConteudoEsquerda />
          <FormWrapper>
            <div>
              <h5 className="first-text">Redefinir senha</h5>
            </div>
            <div className="mt-4">
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <CommonInputSenha
                    label="Digite a nova senha"
                    id="senha"
                    value={values.senha}
                    onChange={(e) => {
                      handleChange(e, values, setValues);
                    }}
                    auth
                  />
                </div>
                <div className="mb-3">
                  <CommonInputSenha
                    label="Digite novamente a nova senha"
                    id="confirmSenha"
                    value={values.confirmSenha}
                    onChange={(e) => {
                      handleChange(e, values, setValues);
                    }}
                    auth
                  />
                </div>
                <div className="mt-3 mb-3 d-grid right-footer">
                  <button
                    className="btn btn-primary waves-effect waves-light auth-button"
                    type="submit"
                  >
                    Definir
                  </button>
                </div>
              </form>
            </div>
          </FormWrapper>
        </div>
      </div>
    </>
  );
}

export default ResetSenha;
